/**
 * Karina API Status Error
 * 니콜라스와 다른 코드를 가져갑니다. 아직 정의된 코드는 없습니다.
 */
export enum ApiStatusCodeVo {
  Success = 0,
  Fail = -1,
}
